import { TRADER_API } from "../constants/api";
import { GetTraderParamModel } from "../model/common";
import { getHeadersWithTokenOnly, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";

export default class TraderService {
  getTradersService(params: GetTraderParamModel) {
    const url = getUrl(TRADER_API.LIST);
    const headers = getHeadersWithTokenOnly(params);
    const options: any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });
  }
}
